/**
* @Author: glb
* @Description: 将所有需要单独调  公用接口获取下拉别表的  select框进行封装
* @Description: searchType  owner-货主  status-质量类型 goodsCategory-商品类别 storehouseZone-区域 storehouseZoneCode-区域 StorehouseArea-库区
* @Description: searchType  supplier-供应商  distributor-配送商 customer-客户
* @DateTime: Created in 14:30 2017/12/29
*/
<template>
	<div>
		<Select
				ref="select" :value="value" @input="input" @on-change="onChange" :filterable="filterable" :clearable="!disabled && clearable" :size="size" :label-in-value="labelInValue"
				:placeholder="placeholderDefault" :disabled="disabled" :multiple="multiple" :transfer="transfer" :defaultMatch="defaultMatch">
			<!--货主 供应商 承运商 客户 承运单位-->
			<template v-if="searchType==='owner' || searchType==='ownerNameFilter'">
				<Option v-for="item in dataSource" :key="item.code" :value="item.name">{{item.name}}</Option>
			</template>
			<template v-if="searchType==='ownerCode'||searchType==='ownerCodeFilter'||searchType==='supplier'||searchType==='distributor'||searchType==='customer'||searchType==='carrier'||searchType==='goodsStatus'||searchType==='processType'||searchType==='goodsStateWithAuth'">
				<Option v-for="item in dataSource" :key="item.code" :value="useNameAsValue?item.name:item.code">{{item.name}}</Option>
			</template>
			<!--质量类型-->
			<template v-if="searchType==='status'">
				<Option v-for="item in dataSource" :key="item.code" :value="item.code">{{item.status}}</Option>
			</template>
			<!--商品类别-->
			<template v-if="searchType==='goodsCategory'">
				<Option v-for="item in dataSource" :key="item.goodsCategoryId" :value="useNameAsValue?item.name:(useIdAsValue?item.goodsCategoryId:item.code)">{{item.name}}</Option>
			</template>
			<!--仓库区域-->
			<template v-if="searchType==='storehouseZone'">
				<Option v-for="item in dataSource" :key="item.storehouseZoneId" :value="useNameAsValue?item.name:(useIdAsValue?item.storehouseZoneId:item.code)">{{item.name}}</Option>
			</template>
			<!--仓库区域-->
			<template v-if="searchType==='storehouseZoneCode'">
				<Option v-for="item in dataSource" :key="item.code" :value="item.code">{{item.name}}</Option>
			</template>
			<!--库区-->
			<template v-if="searchType==='StorehouseArea'">
				<Option v-for="item in dataSource" :key="item.code" :value="item.code">{{item.name}}</Option>
			</template>
			<!--字典-->
			<template v-if="searchType==='dictCode'">
				<Option v-for="item in dataSource" :key="item.dictitemCode" :value="useNameAsValue?item.dictitemName:item.dictitemCode">{{item.dictitemName}}</Option>
			</template>
			<!--流程-->
			<template v-if="searchType==='process'">
				<Option v-for="item in dataSource" :key="item.code" :value="useNameAsValue?item.name:item.code">{{item.name}}</Option>
			</template>
			<template v-if="searchType==='storehouse'">
				<Option v-for="item in storehouseList" :key="item.code" :value="useNameAsValue?item.name:item.code">{{item.name}}</Option>
			</template>
			<template v-if="searchType==='shelveRule'">
				<Option v-for="item in dataSource" :key="item.code" :value="useNameAsValue?item.name:item.code">{{item.name}}</Option>
			</template>
		</Select>
	</div>
</template>
<script type="text/ecmascript-6">
import {InterObj} from 'utils/serviceConst'
import {formatPublicDictData} from 'utils/utils'
import clickoutside from 'utils/clickoutside'
import {mapActions, mapGetters} from 'vuex'
import {PROCESSTYPE} from 'src/utils/const'
export default {
    name: 'formSelectSearch',
    directives: {clickoutside},
    props: {
        labelInValue: {
            type: Boolean,
            default: true
        },
        transfer: {
            type: Boolean,
            default: false
        },
        // 选中选项的值 取 code还是name
        useNameAsValue: {
            type: Boolean,
            default: false
        },
        useIdAsValue: {
            type: Boolean,
            default: false
        },
        value: {},
        size: {
            type: String,
            default: 'small'
        },
        placeholder: {
            type: String,
            default: ''
        },
        clearable: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        filterable: {
            type: Boolean,
            default: false
        },
        searchType: {
            type: String,
            required: true
        },
        searchParams: {
            type: Object,
            default: () => {
                return {}
            }
        },
        // 字典类别 只有当searchType='dictCode'时  需要设置
        dictCode: {
            type: String
        },
        // 确保多个相同页面的相同请求不会重复调用
        // 储存一个公共接口的promise
        dataSourcePromise: {
            type: Object
        },
        multiple: {
            type: Boolean,
            default: false
        },
        defaultMatch: {
            type: Boolean
		},
		//	字典项类型时 是否需要默认选中
        setDefault: {
            type: Boolean,
            default: false
		}
    },
    data() {
        return {
            dataSource: []
        }
    },

    computed: {
        ...mapGetters([
            'storehouseList',
        ]),
        placeholderDefault() {
            if (this.placeholder) {
                return this.placeholder
            } else {
                let name = ''
                switch (this.searchType) {
                    case 'owner':
                    case 'ownerCode':
                    case 'ownerNameFilter':
                    case 'ownerCodeFilter':
                        name = '货主'
                        break
                    // 供应商
                    case 'supplier':
                        name = '供应商'
                        break
                    // 客户
                    case 'customer':
                        name = '客户'
                        break
                    // 配送商
                    case 'distributor':
                        name = '配送商'
                        break
                    case 'status':
                        name = '质量类型'
                        break
                    case 'goodsStatus':
                        name = '质量类型'
                        break
                    case 'goodsStateWithAuth':
                        name = '质量类型'
                        break
                    case 'goodsCategory':
                        name = '商品类别'
                        break
                    case 'storehouseZone':
                        name = '区域'
                        break
                    case 'storehouseZoneCode':
                        name = '区域'
                        break
                    case 'StorehouseArea':
                        name = '库区'
                        break
                    case 'process':
                        name = '流程'
                        break
                    case 'storehouse':
                        name = '仓库'
                        break
					case 'shelveRule':
                        name = '上架规则'
                        break
                    case 'processType':
                        name = '流程类型'
                        break
                    default:
                        break
                }
                return `请选择${name}`
            }
        }
    },
    methods: {
        onChange(v) {
            this.$emit('on-change', v)
            let data
            if (this.labelInValue) {
                data =  v && this.dataSource.find(item => item.code === v.value)
            } else {
                data = this.dataSource.find(item => item.code === v)
            }
            this.$emit('selectParams', data)
        },

        input(v) {
            this.$emit('input', v)
        },
        async search(url, param = {}) {
            let {result, data, msg} = await requestMethods.get(url, {...param, ...this.searchParams})
            if (result === 'success') {
                this.dataSource = data || []
                this.$emit('getDataSource', data || [])
                return this.dataSource
            } else {
                this.$Notice.warning({desc: msg})
                return null
            }
        },
        async searchDict(url) {
            if (!this.dictCode) {
                throw new Error(`formSelectSearch组件'searchType'='dictCode'时 必须传入属性dictCode`)
            }
            let {result, data, msg} = await requestMethods.get(url, {code: this.dictCode, ...this.searchParams})

            if (result === 'success') {
                let dictObj = formatPublicDictData(data)
                this.dataSource = dictObj[this.dictCode]
				if (this.setDefault) {
				    let defDict = _.find(this.dataSource, d => d.isDefault === '1') || this.dataSource[0]
					let value = this.useNameAsValue ? defDict.dictitemName : defDict.dictitemCode
                    this.$emit('input', value)
				}
                return dictObj
            } else {
                this.$Notice.warning({desc: msg})
                return null
            }
        },
        init() {
            switch (this.searchType) {
                case 'ownerCode':
                    // 货主
                    this.ajaxPromise = this.search(InterObj.queryOwnerList, {type: 0})
                    break
                case 'owner':
                    this.ajaxPromise = this.search(InterObj.queryOwnerList, {type: 0})
                    break
                case 'ownerNameFilter': // 根据登录信息获取所有绑定的货主
                    this.ajaxPromise = this.search(InterObj.queryOwnerListFilter, {type: 0})
                    break
                case 'ownerCodeFilter': // 根据登录信息获取所有绑定的货主
                    this.ajaxPromise = this.search(InterObj.queryOwnerListFilter, {type: 0})
                    break
                // 供应商
                case 'supplier':
                    this.ajaxPromise = this.search(InterObj.queryOwnerList, {type: 1})
                    break
                // 客户
                case 'customer':
                    this.ajaxPromise = this.search(InterObj.queryOwnerList, {type: 2})
                    break
                // 承运商
                case 'distributor':
                    this.ajaxPromise = this.search(InterObj.queryOwnerList, {type: 3})
                    break
                // 承运商
                case 'carrier':
                    this.ajaxPromise = this.search(InterObj.queryOwnerList, {type: 4})
                    break
                // 质量类型
                case 'status':
                    this.ajaxPromise = this.search(InterObj.queryGoodsQuality)
                    break
                // 质量类型
                case 'goodsStatus':
                    this.ajaxPromise = this.search(InterObj.queryGoodsStatusByOwner)
                    break
                // 质量类型
                case 'goodsStateWithAuth':
                    this.ajaxPromise = this.search(InterObj.goodsStateWithAuth)
                    break
                // 商品类别
                case 'goodsCategory':
                    this.ajaxPromise = this.search(InterObj.queryGoodsCategoryList)
                    break
                // 仓库区域
                case 'storehouseZone':
                    this.ajaxPromise = this.search(InterObj.selectStorehouseZoneList)
                    break
                // 仓库区域
                case 'storehouseZoneCode':
                    this.ajaxPromise = this.search(InterObj.selectStorehouseZoneList)
                    break
                // 库区
                case 'StorehouseArea':
                    this.ajaxPromise = this.search(InterObj.selectStorehouseAreaList)
                    break
                case 'dictCode':
                    this.ajaxPromise = this.searchDict(InterObj.selectDictItemListByDictCode)
                    break
                case 'process':
                    this.ajaxPromise = this.search(InterObj.selectInboundProcessList)
                    break
                case 'shelveRule':
                    this.ajaxPromise = this.search(InterObj.queryShelveRule)
                    break
                case 'processType':
                    this.dataSource = PROCESSTYPE
                    break
                default:
                    break
            }
        }
    },
    mounted() {
        if (this.dataSourcePromise && this.dataSourcePromise.promise) {
            this.ajaxPromise = this.dataSourcePromise.promise
            this.ajaxPromise.then((data) => {
                if (data) {
                    if (this.searchType === 'dictCode') {
                        this.dataSource = data[this.dictCode]
                    } else {
                        this.dataSource = data
                    }
                }
            })
            return
        }
        this.init()
        if (this.dataSourcePromise && !this.dataSourcePromise.promise) {
            this.dataSourcePromise.promise = this.ajaxPromise
        }
    },
	created() {
        this.$on('form-select-search-init', this.init)
	},
    watch: {
        dataSource(val) {
            let data = val.find(item => item.code === this.value)
            this.$emit('selectParams', data)
        }
    }
}
</script>
